export function getLocalSettings() {
    const localSettings = localStorage.getItem('localSettings');
    if (localSettings != null) {
        return JSON.parse(localSettings);
    }
    return null;
}
function saveSettings(localSettings) {
    return localStorage.setItem('localSettings', JSON.stringify(localSettings));
}
export function updateSettings(payload) {
    const { key, value } = payload;
    return new Promise((resolve, reject) => {
        try {
            const localSettings = getLocalSettings() || {};
            localSettings[key] = value;
            saveSettings(localSettings);
            return resolve(localSettings);
        }
        catch (e) {
            return reject(e);
        }
    });
}
export function updateReplyAreaHeight(payload) {
    return updateSettings({
        key: 'replyAreaHeight',
        value: payload.value,
    });
}
export function toggleStrictSearch(payload) {
    return updateSettings({
        key: 'strictSearch',
        value: payload.value,
    });
}
export function toggleRememberMicrophoneAccess(payload) {
    return updateSettings({
        key: 'skipMicrophoneAccess',
        value: payload.value,
    });
}
export function toggleRememberElevioCardOpen(payload) {
    return updateSettings({
        key: 'elevioCardOpen',
        value: payload.elevioCardOpen,
    });
}
export function toggleElevioSelectedLanguage(payload) {
    return updateSettings({
        key: 'elevioSelectedLanguage',
        value: payload.elevioSelectedLanguage,
    });
}
export function toggleRememberKnowledgeCardOpen(payload) {
    return updateSettings({
        key: 'knowledgeCardOpen',
        value: payload.knowledgeCardOpen,
    });
}
export function updateConversationCards(payload) {
    const { conversationCards } = getLocalSettings() || {};
    const { key, value } = payload;
    return updateSettings({
        key: 'conversationCards',
        value: Object.assign(Object.assign({}, conversationCards), { [key]: value }),
    });
}
export function addToFavouriteQueueIds(payload) {
    const { favouriteQueueIds = [] } = getLocalSettings() || {};
    const { queueId } = payload;
    const updated = favouriteQueueIds.includes(queueId)
        ? favouriteQueueIds
        : [...favouriteQueueIds, queueId];
    return updateSettings({
        key: 'favouriteQueueIds',
        value: updated,
    });
}
export function removeFromFavouriteQueueIds(payload) {
    const { favouriteQueueIds = [] } = getLocalSettings() || {};
    const { queueId } = payload;
    const updated = favouriteQueueIds.filter((id) => id !== queueId);
    return updateSettings({
        key: 'favouriteQueueIds',
        value: updated,
    });
}
export function addToFavouriteTeamMemberIds(payload) {
    const { favouriteTeamMemberIds = [] } = getLocalSettings() || {};
    const { agentId } = payload;
    const updated = favouriteTeamMemberIds.includes(agentId)
        ? favouriteTeamMemberIds
        : [...favouriteTeamMemberIds, agentId];
    return updateSettings({
        key: 'favouriteTeamMemberIds',
        value: updated,
    });
}
export function removeFromFavouriteTeamMemberIds(payload) {
    const { favouriteTeamMemberIds = [] } = getLocalSettings() || {};
    const { agentId } = payload;
    const updated = favouriteTeamMemberIds.filter((id) => id !== agentId);
    return updateSettings({
        key: 'favouriteTeamMemberIds',
        value: updated,
    });
}
